/**
 * @module app.core
 */

import { ICustomFieldDefinitionContainer, ICustomFieldsTarget, ICustomFieldDefinitionsTextCollectionIndexer, ICustomFieldDefinitionsLookupCollectionIndexer } from 'app/core/components/custom-fields/interfaces';
import { getReference } from 'app/shared/models/essette-types';
import { forceNull } from 'app/shared/lib/utilities';
import * as CD from 'app/cd/models/essette-api';

// Strip extraneous fields from the UDF Text values and ensure that no empty strings are passed to API
export function parseTextContainer(text: CD.CustomFieldDefinitionTextContainer | undefined): CD.CustomFieldDefinitionTextContainer | undefined {
    if(!text) return text;
    const VALUE_FIELD = 'value';
    let newText: CD.CustomFieldDefinitionTextContainer = {};
    Object.entries(text).forEach((field: [string, any]) => {
        const fieldKey = field[0];
        if(fieldKey.includes(VALUE_FIELD)) {
            newText = {
                ...newText,
                [fieldKey]: forceNull(field[1])
            };
        }
    });

    return newText;
}

// Strip extraneous fields from the UDF Lookup Values
export function parseLookupContainer(lookup: CD.CustomFieldDefinitionLookupContainer | undefined): CD.CustomFieldDefinitionLookupContainer | undefined {
    if(!lookup) return lookup;
    const CHOICE_FIELD = 'choice';
    let newLookup: CD.CustomFieldDefinitionLookupContainer = {};
    Object.entries(lookup).forEach((field: [string, any]) => {
        const fieldKey = field[0];
        if(fieldKey.includes(CHOICE_FIELD)) {
            newLookup = {
                ...newLookup,
                [fieldKey]: field[1] ? { code: field[1].code } : null
            };
        }
    });

    return newLookup;
}

export function getCustomFieldDefinitionReferences(container?: ICustomFieldDefinitionContainer, target?: ICustomFieldsTarget | null): ICustomFieldDefinitionContainer | undefined {
    if(!container || !target || !target.definitions) { return undefined; }

    const result: ICustomFieldDefinitionContainer = {};

    if(container.text) {
        result.text = { };
        for(const definition of target.definitions) {
            if(definition.property && definition.property.field && definition.property.type === 'text') {
                (result.text as ICustomFieldDefinitionsTextCollectionIndexer)[definition.property.field] =
                    (container.text as ICustomFieldDefinitionsTextCollectionIndexer)[definition.property.field];
            }
        };
    }
    if(container.lookup) {
        result.lookup = { };
        for(const definition of target.definitions) {
            if(definition.property && definition.property.field && definition.property.type === 'lookup') {
                (result.lookup as ICustomFieldDefinitionsLookupCollectionIndexer)[definition.property.field] =
                    getReference((container.lookup as ICustomFieldDefinitionsLookupCollectionIndexer)[definition.property.field]) || null;
            }
        };
    }

    return result;
}
